export class Page {
  name: string;
  url: string;
  constructor(name: string, url: string) {
    this.name = name;
    this.url = url;
  }

  isSameUrl = (url: string) => {
    // check if the page url has any placeholders (e.g. /auth-redirect/:providerId)
    // and take that into account when comparing
    const pageUrlParts = this.url.split('/');
    const urlParts = url.split('/');
    if (pageUrlParts.length !== urlParts.length) {
      return false;
    }
    for (let i = 0; i < pageUrlParts.length; i++) {
      if (pageUrlParts[i].startsWith(':')) {
        continue;
      }
      if (pageUrlParts[i] !== urlParts[i]) {
        return false;
      }
    }
    return true;
  };

  withPlaceholders = (placeholders: string[]) => {
    let url = this.url;
    placeholders.forEach((placeholder) => {
      url = url.replace(/:[^/]+/, placeholder);
    });
    return url;
  };
}

// Get dashboard URL from env
import env from './env';

// Public routes (on Landing site)
const HOME_PAGE = new Page('Home', '/');
const PRICING_PAGE = new Page('Pricing', '/pricing');
const ABOUT_PAGE = new Page('About', '/about');
const PAY_PAGE = new Page('Pay', '/pay');
const EXPLORE_ADD_ONS_PAGE = new Page('Explore Add-Ons', '/explore');
const TERMS_OF_SERVICE_PAGE = new Page('Terms of Service', '/terms-of-service');
const PRIVACY_POLICY_PAGE = new Page('Privacy Policy', '/privacy-policy');
const REFUND_POLICY_PAGE = new Page('Refund Policy', '/refund-policy');
const COOKIE_POLICY_PAGE = new Page('Cookies Policy', '/terms-of-service#cookie');
const ACCEPTABLE_USE_POLICY_PAGE = new Page('Acceptable Use Policy', '/terms-of-service#aup');
const FORMS_PAGE = new Page('Forms', '/forms');
const ADD_ON_SUGGESTIONS_FORM_PAGE = new Page(
  'Add-On Suggestions Form',
  `${FORMS_PAGE.url}/add-on-suggestions`
);
const BUG_REPORT_FORM_PAGE = new Page('Bug report Form', `${FORMS_PAGE.url}/bug-report`);
const DOCS_PAGE = new Page('Docs', '/docs');
const HELP_PAGE = new Page('Help', '/help-center');
const PAGE_NOT_FOUND_PAGE = new Page('Page Not Found', '/404');

// External pages (on Dashboard site) - full URLs
const SIGN_IN_PAGE = new Page('Sign In', `${env.DASH_URL}/signin`);
const SIGN_UP_PAGE = new Page('Sign Up', `${env.DASH_URL}/signup`);
const APP_PAGE = new Page('App', `${env.DASH_URL}/app`);
const DASHBOARD_ADD_ONS_PAGE = new Page('Add-ons', `${env.DASH_URL}/app/add-ons`);
const CONNECT_PAGE = new Page('Connect Add On', `${env.DASH_URL}/connect`);

const PUBLIC_PAGES = {
  HOME_PAGE,
  PRICING_PAGE,
  ABOUT_PAGE,
  PAY_PAGE,
  EXPLORE_ADD_ONS_PAGE,
  TERMS_OF_SERVICE_PAGE,
  PRIVACY_POLICY_PAGE,
  REFUND_POLICY_PAGE,
  COOKIE_POLICY_PAGE,
  ACCEPTABLE_USE_POLICY_PAGE,
  FORMS_PAGE,
  ADD_ON_SUGGESTIONS_FORM_PAGE,
  BUG_REPORT_FORM_PAGE,
  DOCS_PAGE,
  HELP_PAGE,
  PAGE_NOT_FOUND_PAGE,
};

const EXTERNAL_PAGES = {
  SIGN_IN_PAGE,
  SIGN_UP_PAGE,
  APP_PAGE,
  DASHBOARD_ADD_ONS_PAGE,
  CONNECT_PAGE,
};

const urlToPage = (url: string): Page => {
  const page = Object.values(PUBLIC_PAGES).find((page) => page.isSameUrl(url));
  if (page) {
    return page;
  }
  return PAGE_NOT_FOUND_PAGE;
};

const pages = {
  ...PUBLIC_PAGES,
  ...EXTERNAL_PAGES,
  urlToPage,
};

export default pages;
